// extracted by mini-css-extract-plugin
export var chip = "_5g-9";
export var chipLabel = "_5g-a";
export var close = "_5g-7";
export var closeIcon = "_5g-8";
export var error = "_5g-6";
export var infoTooltip = "_5g-2";
export var innerContainer = "_5g-1";
export var input = "_5g-b";
export var medium = "_5g-5";
export var outerContainer = "_5g-0";
export var small = "_5g-4";
export var xSmall = "_5g-3";